import React from 'react';
import { createContext, useCallback, useContext, useState } from 'react';

interface IDrawerContextData {
    isDrawerOpen: boolean;
    isEnableDrawerHover: boolean;
    drawerOptions: IDrawerOption[];
    setDrawerOptions: (newDrawerOptions: IDrawerOption[]) => void;
    handleToggleDrawer: () => void;
}

interface IDrawerOption {
    icon: string;
    path: string;
    label: string;
    childrens?: IDrawerOption[];
    IconColor?: 'inherit' | 'disabled' | 'action' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | undefined;
}
const DrawerContext = createContext({} as IDrawerContextData);

export const useDrawerContext = (): IDrawerContextData => {
    return useContext(DrawerContext);
};

interface IDrawerProviderProps {
    children: React.ReactNode;
}
export const DrawerProvider: React.FC<IDrawerProviderProps> = ({ children }) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(true);
    const [drawerOptions, setDrawerOptions] = useState<IDrawerOption[]>([]);

    const [isEnableDrawerHover, setIsEnableDraweHover] = useState<boolean>(false);

    const handleToggleDrawer = useCallback(() => {
        setIsDrawerOpen(oldDrawerOpen => !oldDrawerOpen);
        setIsEnableDraweHover(false);
    }, []);

    const handleSetDrawerOptions = useCallback((newDrawerOptions: IDrawerOption[]) => {
        setDrawerOptions(newDrawerOptions);
    }, []);

    return (
        <DrawerContext.Provider value={{ isDrawerOpen, drawerOptions, isEnableDrawerHover, handleToggleDrawer, setDrawerOptions: handleSetDrawerOptions }}>
            {children}
        </DrawerContext.Provider>
    );
};